export const LOYALTY_KLAVIYO_EXTERNAL_ID_COOKIE = 'ved.shared.klaviyo.externalId';
